import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetStepperComponent } from './useGetStepperComponent'
import { StepperComponentContent } from './StepperComponentContent'

export const StepperComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetStepperComponent(id, tileFilterSelections)

  return (
    <StepperComponentContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function StepperComponentLoading() {
  return 'Loading...'
}
